// client/extensions/Link/Link.ts
import { DesignSystem } from "@adornis/chemistry/elements/theming/design.js";
import { mergeAttributes } from "@tiptap/core";
import TiptapLink from "@tiptap/extension-link";
import { XTiptapPromptLink } from "./x-tiptap-prompt-link.js";
var LinkTranslations = {
  link: {
    tooltip: {
      linkAdd: ["Link einf\xFCgen", "Add link"],
      linkRemove: ["Link entfernen", "Remove Link"]
    }
  }
};
var Link = {
  buttons: ({ editor, host }) => {
    const buttons = [
      {
        name: "insertLink",
        icon: "link",
        action: async () => {
          const existingLink = editor.getAttributes("link");
          if (existingLink?.href) {
            const editedLink = await XTiptapPromptLink.showPopup({
              props: {
                href: existingLink.href,
                openInNewTab: existingLink?.target === "_blank"
              }
            });
            if (!editedLink)
              return;
            editor.chain().extendMarkRange("link").updateAttributes("link", { href: editedLink.href, target: editedLink.target }).run();
            return;
          }
          const link = await XTiptapPromptLink.showPopup();
          if (link?.href === null || link?.href === void 0)
            return;
          editor.commands.setLink({ ...link });
        },
        tooltip: host.translator.translate("tiptap", "link", "tooltip", "linkAdd")
      }
    ];
    if (editor.getAttributes("link").href)
      buttons.push({
        name: "removeLink",
        icon: "link_off",
        action: async () => {
          editor.chain().focus().unsetLink().run();
        },
        tooltip: host.translator.translate("tiptap", "link", "tooltip", "linkRemove")
      });
    return buttons;
  },
  extensions: [
    TiptapLink.extend({
      renderHTML({ HTMLAttributes }) {
        return [`${DesignSystem.prefix}-link`, mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
      },
      parseHTML() {
        return [{ tag: "x-link" }, { tag: `${DesignSystem.prefix}-link` }];
      },
      addAttributes() {
        return {
          href: {
            default: null
          },
          target: {
            default: this.options.HTMLAttributes.target
          },
          icon: {
            default: "link",
            renderHTML(attributes) {
              return {
                icon: "link",
                style: "text-decoration: underline"
              };
            }
          }
        };
      }
    })
  ]
};
export {
  Link,
  LinkTranslations
};
